<template>
  <div>
     <h4
      v-if="heading !== ''"
      class="text-sm uppercase font-bold text-gray-700 tracking-wide"
    >{{ heading }}</h4>
    <textarea
      class="mt-2 form-input w-full"
      rows=3
      :class="{'cursor-not-allowed':disabled}"
      :disabled="disabled"
      v-model="text"
      aria-describedby="other-live-feedback"
    ></textarea>
    <p
      v-if="required"
      id="other-live-feedback"
      class="mt-1 absolute text-red-500 text-sm"
      ref="otherErrorText"
    >Please complete the sentence.</p>
  </div>
</template>

<script>
export default {
  name: 'MTextarea',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    text: '',
  }),
  watch: {
    modelValue: {
      handler(value) {
        this.text = value;
      },
      immediate: true,
    },
    text(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style>

</style>
